<div class="technical-error-container" *ngIf="showPageNotFound">
  <img src="assets/generalImage/not_found.svg" alt="mascot" />
  <h1 class="heading-8">{{'page.not.found.title.1' | translate}}</h1>
  <app-button [buttonName]="'button.back.to.home' | translate" (click)="navigateHome()" class="submit-btn"></app-button>
</div>
